import { eudrClient } from '@/utils/EudrClient.js'
import { featureDisplayName } from '@/utils/eudr/EudrFeatureName.js'
import { EudrBatchStatus } from '@/utils/Enumerations.js'

// Single source of truth so the manager dialog and the account EUDR tab agree on which statuses have a result blob.
export function hasUsableResult (report) {
  const usable = [
    EudrBatchStatus.Complete.value,
    EudrBatchStatus.NeedsValidation.value,
    EudrBatchStatus.Validated.value,
    EudrBatchStatus.Finalized.value
  ]
  return !!report?.resultBlobPath && usable.includes(report.status)
}

// Composite features carry EU PascalCase props and no tract identity, so both naming schemes must be tried.
export function featuresToTractRows (features) {
  const byTract = new Map()
  features.forEach((f, index) => {
    const p = f.properties ?? {}
    const name = (p.productionPlace ?? p.ProductionPlace) || null
    // Third-party features often carry no tract identity, and must never lump into one anonymous "undefined" row.
    const key = p.tractId ?? name ?? p.parcelId ?? `feature-${index}`
    if (!byTract.has(key)) {
      byTract.set(key, {
        tractName: featureDisplayName(f),
        parcelId: p.parcelId,
        conflict: false,
        // Every feature belonging to this row (a multipart tract has several), so the dialog can zoom to them.
        features: []
      })
    }
    byTract.get(key).features.push(f)
    if (p.conflict === true) byTract.get(key).conflict = true
  })
  return [...byTract.values()]
}

// Returns tract rows plus a frozen FeatureCollection for the map. Throws on fetch/parse failure.
export async function loadReportDetail (resultBlobPath) {
  const blob = await eudrClient.fetchReportBlob(resultBlobPath)
  const eudrPackage = JSON.parse(await blob.text())
  const features = eudrPackage?.features ?? []
  return {
    tracts: featuresToTractRows(features),
    featureCollection: Object.freeze({ type: 'FeatureCollection', features })
  }
}
